export default __webpack_public_path__ + "static/media/ia_img.c3def666.jpg";